<template>
  <div class="abnormal_wrapper">
    <van-nav-bar
      title="异常订单"
      @click-left="$utils.goBack()"
      @click-right="showCondition = !showCondition"
    >
      <template #left>
        <span class="icon-left"></span>
      </template>
      <template #right>
        <div class="nav_right_icon">
          <span class="icon-search1">
            <span class="path1"></span>
            <span class="path2"></span>
            <span class="path3"></span>
          </span>
        </div>
      </template>
    </van-nav-bar>

    <!-- <div class="abnormal_search_box">
      <transition tag="div">
        <div v-show="isSearch" class="searchCondition"> -->
          <!-- 日期选择器 -->
          <!-- <div class="abnormal_picker">
            <date-picker @editDate="editDate"></date-picker>
            <div class="abnormal_condition" @click="showCondition = !showCondition">
              <span class="icon-sceen"></span>
            </div>
          </div> -->

          <!-- 搜索框 -->
          <!-- <div class="abnormal_search">
            <van-search
              left-icon="photo-o"
              background="rgb(246,246,246)"
              v-model.trim="keyword"
              placeholder="请输入车位号/车牌号"
            > -->
              <!-- <template #left-icon>
                <div class="search_icon" @click="scanPlateNumber">
                  <img src="../../assets/images/scan.png" alt />
                </div> -->
                <!-- <span class="icon-camera" @click="scanPlateNumber">
                  <span class="path1"></span>
                  <span class="path2"></span>
                </span>-->
              <!-- </template> -->
              <!-- <template #right-icon>
                <span class="icon-search1">
                  <span class="path1"></span>
                  <span class="path2"></span>
                  <span class="path3"></span>
                </span>
              </template>-->
            <!-- </van-search>
          </div>
        </div>
      </transition>
    </div> -->

    <transition tag="div" name="condition">
      <div class="condition_picker" v-show="showCondition">
        <van-radio-group v-model="conditionRadio">
          <van-radio :name="null">全部</van-radio>
          <van-radio :name="10">支付中</van-radio>
          <van-radio :name="14">支付失败</van-radio>
        </van-radio-group>
      </div>
    </transition>

    <div :class="{'active' : isSearch}" class="abnormal_list">
      <list-view
        :list="notesList"
        :isRefresh="isRefresh"
        :isLoadMore="isLoadMore"
        :isNoMore="isNoMore"
        :isErr="isErr"
        :isAutoLoadMore="isAutoLoadMore"
        @onLoadMore="onListLoadMore"
        @onRefresh="onListRefresh"
      >
        <!-- 订单列表 -->
        <template slot="item">
          <div class="notes_list">
            <li
              @click="onClickItem(item.plateNumber,item.id )"
              class="notes_item"
              v-for="(item , index) in notesList"
              :key="index"
            >
              <div class="item_top">

                <div class="car_license">
                  {{item.plateNumber}}
                  <span
                          class="item_orderStatus"
                          :class="{'fail' : $condition.isOrderStatus_fail(item.orderStatus)}"
                  >{{item.orderStatus | orderStatusFilter}}</span>
                </div>
                <div class="item_cost">{{item.payableAmount}}元</div>


              </div>

              <div class="item_middle">
                <div class="car_pid">{{item.parkingNumber}}</div>


              </div>
              <div class="item_bottom">
                <div class="item_time">{{item.leaveTime}}</div>
                <div class="item_duration">{{item.stayTime | timeTransformation}}</div>
              </div>
            </li>
          </div>
        </template>
      </list-view>
    </div>

    <!-- <div class="abnormal_test"></div> -->
  </div>
</template>

<script>
import listView from "../../components/ListView";
import { ORDER_PARKING_EXCEPTION_ORDER_PARKING_LIST } from "../../config/config";
import { Toast } from "vant";
// import JsBridge from "../../utils/JSBridge/JsBridge";
export default {
  name: "Abnormal",
  data: () => ({
    keyword: "",
    startDate: new Date(),
    endDate: new Date(),
    conditionRadio: null,
    showCondition: false,
    isSearch: false,

    isRefresh: false, //刷新
    isLoadMore: false, //加载
    isNoMore: false, //加载完毕
    isErr: false, //报错
    notesList: [], //订单列表
    isAutoLoadMore: true, //自动加载
    lastId: "", //最后一条订单的id
    plateNumber: "", //车牌号码
  }),
  methods: {
    //接收组件日期值，修改参数
    // editDate(startDate, endDate) {
    //   if (startDate && endDate) {
    //     this.startDate = startDate;
    //     this.endDate = endDate;
    //   }
    // },

    //扫描车牌号码
    // scanPlateNumber() {
    //   JsBridge.callHandler("scanPlateNumber", null, (res) => {
    //     let data = JSON.parse(res);

    //     this.keyword = data["plateNumber"];
    //   });

    //   // this.$utils.scanPlateNumber((res) => {
    //   // });
    // },

    //刷新请求封装
    requestRefreash() {
      //清空lastId
      this.lastId = "";

      //请求数据
      this.$request(
        ORDER_PARKING_EXCEPTION_ORDER_PARKING_LIST,
        {
          orderStatus: this.conditionRadio,
        },
        (res) => {
          Toast("刷新完成");
          if (res["data"]["orderParkingList"]) {
            let data = res["data"]["orderParkingList"];
            //判断是否有数据
            if (data.length > 0) {
              //赋值，刷新页面
              this.lastId = data[data.length - 1]["id"];
              this.notesList = data;
              this.isRefresh = false;
            } else {
              this.notesList = [] ;
              this.isNoMore = true;
              this.isRefresh = false;
            }
          } else {
            Toast("数据请求失败，请重试");
          }
        }
      );
    },

    //列表刷新
    onListRefresh() {
      this.isRefresh = true;

      //防抖
      clearTimeout(this.refreshTimer);
      this.refreshTimer = setTimeout(() => {
        this.refreshTimer = null;
        this.requestRefreash();
      }, 500);
    },

    //列表加载
    onListLoadMore() {
      this.isLoadMore = true;

      //防抖
      clearTimeout(this.loadTimer);
      this.loadTimer = setTimeout(() => {
        this.loadTimer = null;
        //请求数据
        this.$request(
          ORDER_PARKING_EXCEPTION_ORDER_PARKING_LIST,
          {
            lastId: this.lastId,
            orderStatus: this.conditionRadio,
          },
          (res) => {
            if (res["data"]["orderParkingList"]) {
              let data = res["data"]["orderParkingList"];
              if (data.length > 0) {
                //记录数据，赋值
                this.isLoadMore = false;
                this.lastId = data[data.length - 1]["id"];

                data.forEach((item) => {
                  this.notesList.push(item);
                });
              } else {
                this.isNoMore = true;
              }
            } else {
              Toast("数据请求失败，请重试");
            }
          }
        );
      }, 500);
    },

    //点击列表
    onClickItem(plateNumber, orderParkingId) {
      if (plateNumber && orderParkingId) {
        this.$router.push({
          name: "PendingOrder",
          params: { orderParkingId, plateNumber },
        });
      }
    },
  },
  components: {
    listView,
  },
  watch: {

    conditionRadio(newV, oldV) {

      clearTimeout(this.conditionTimeout);

      if (newV != oldV && newV != "") {
        this.conditionTimeout = setTimeout(() => {
          this.conditionTimeout = null;
          this.onListRefresh();
        });
      }
    },
  },
  filters: {
    orderStatusFilter(orderStatus) {
      if (orderStatus == 10) {
        return "支付中";
      } else {
        return "支付失败";
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      //改变顶部状态栏
      vm.$utils.changeStatusBarStyle("black");
      let { plateNumber } = vm.$route.params;
      if (plateNumber) {
        vm.plateNumber = plateNumber;
      }
    });
  },
};
</script>

<style lang="less" scoped >
.v-enter-to,
.v-leave {
  opacity: 1;

  z-index: 1;
  height: 84px;
}

.v-enter,
.v-leave-to {
  opacity: 0;
  z-index: -1;
  height: 0;
}

.v-enter-active,
.v-leave-active {
  transition: all 0.3s;
}

.condition-enter,
.condition-leave-to {
  transform: translateX(100%);
}

.condition-enter-to,
.condition-leave {
  transform: translateX(0);
}
.condition-enter-active,
.condition-leave-active {
  transition: all 0.3s;
}

.abnormal_wrapper {
  width: 100vw;
  height: 100vh;
  background-color: #fff;
  position: absolute;
  padding-top: 26px;
  top: 0;
  left: 0;
  overflow: hidden;

  .icon-left {
    font-size: 24px;
    margin-right: 6px;
    color : #333 ;
  }

  .nav_right_icon {
    font-size: 24px;
    color: #666;
  }

  /deep/ .van-nav-bar__title {
    font-size: 20px;
  }
}

.abnormal_picker {
  height: 50px;
  padding: 0 12px;
  display: flex;
  justify-content: space-between;
  background-color: rgb(246, 246, 246);

  .abnormal_condition {
    display: flex;
    align-items: center;
    font-size: 24px;
  }
}

.abnormal_search {
  .search_icon {
    width: 24px;
    height: 24px;

    > img {
      width: 100%;
      height: 100%;
    }
  }
  .van-search {
    padding-top: 0;

    .van-cell {
      font-size: 20px;

      /deep/ .van-field__control {
        font-size: 14px;
      }
    }
  }

  .van-search__content {
    background-color: #fff;
  }
}

.abnormal_search_box {
  overflow: hidden;
  position: relative;
  z-index: 52;

  .searchCondition {
    overflow: hidden;
  }
}

.abnormal_test {
  width: 100%;
  height: 1000px;
  background-color: red;
}

.abnormal_list {
  position: absolute;
  top: 66px;
  bottom: 0;
  width: 100%;
  overflow: hidden;
  // transition: top 0.5s;

  // &.active {
  //   top: 152px;
  // }

  .notes_list {
    width: 100%;
    padding: 0 20px;
  }

  .notes_item {
    width: 100%;
    min-height: 88px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    font-size: 20px;
    padding: 10px 0;
    border-bottom: 1px solid rgba(7, 17, 27, 0.1);

    .item_top {
      display: flex;
      justify-content: space-between;
      margin-bottom  : 8px ;

      .car_license {
        color: #000;
        font-weight: 700;
        font-size: 20px;

        .item_orderStatus {
          margin-left: 20px;
          color: skyblue;

          &.fail {
            color: red;
          }
        }
      }
      .item_cost {
        color: red;
        font-size: 20px;
        font-weight: 600;
      }


    }

    .item_middle{
      margin-bottom : 8px ;

      .car_pid{
        color : #333 ;
        display: inline-block;
        width : 240px ;
        vertical-align: baseline;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }



    .item_bottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: rgb(129, 129, 129);
      font-size : 18px ;
    }
  }
}

.condition_picker {
  width: 150px;

  position: absolute;
  top: 65px;
  right: 0px;
  z-index: 52;
  background-color: rgba(7, 17, 27, 0.6);
  color: #fff;
  font-size: 20px;
  padding: 14px;

  .van-radio {
    // margin-bottom: 10px;
    padding : 14px 0 ;

    &:last-child {
      margin-bottom: 0;
    }

    /deep/ .van-radio__label {
      color: #fff;
    }
  }
}
</style>
